import { inject } from '@angular/core';
import { KeycloakService } from '@ui/legacy-lib';
import {
  ActivatedRouteSnapshot,
  RedirectCommand,
  Router
} from '@angular/router';

export const projectRegistrationLinkGuard = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const keycloakService = inject(KeycloakService);

  const url = keycloakService.token
    ? ['search-profiles']
    : ['auth', 'register', 'propertyLocation'];

  return new RedirectCommand(
    router.createUrlTree(url, {
      queryParams: {
        project: route.params.token
      }
    })
  );
};
